import { Paper } from "@mui/material";
import {useOutletContext} from "react-router-dom"
import { DataGrid,GridToolbarContainer,GridToolbarFilterButton, GridToolbarQuickFilter} from '@mui/x-data-grid';
import { useState } from "react";
import ReAuthDeleteDialog from "../../components/ReAuthDeleteDialog";
import { Chemical as Managed } from "../../features/db/chemical";
import Dialog from "../../components/NewChemicalDialog";

export default function ChemicalPage() {
	const { chemicalsContainer } = useOutletContext();
	const [rows, setRows] = chemicalsContainer;

	const [selectionModel, setSelectionModel] = useState([]);

	const columns = [
		{ field: 'name', headerName: 'Chemical', flex:1}
	];

	const submitCallback = (p)=>
	{
		setRows([...rows, p]);
	}

	const handleDelete = ()=>
	{
		if(selectionModel.length > 0)
		{
			Managed.deleteAndUpdate(selectionModel,rows,setRows);
		}
	}

	const CustomToolbar = ({ setFilterButtonEl }) => (
		<GridToolbarContainer sx = {{m:1}}>
			<GridToolbarQuickFilter />
			<GridToolbarFilterButton ref={setFilterButtonEl} />
			<Dialog submitCallback={submitCallback}/>
			<ReAuthDeleteDialog handleDelete = {handleDelete} selectionSize = {selectionModel.length}/>
		</GridToolbarContainer>
	);

	return (
		<Paper varient="outlined" sx={{m:2}} elevation={10}>
			<DataGrid
				autoHeight
				rows={rows}
				columns={columns}
				checkboxSelection
				components={{Toolbar: CustomToolbar }}
				disableColumnSelector
				disableDensitySelector
				onSelectionModelChange = {(newSelectionModel) => {
					setSelectionModel(newSelectionModel);
				}}
				selectionModel={selectionModel}
				getRowHeight={() => 'auto'}
			/>
		</Paper>
	);
}